import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { Autocomplete } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';

const CoddingGroupListAddModal = ({
  open,
  codeList,
  handleClose,
  reFetch,
  item,
  onAdd,
}) => {
  const [selected, setSelected] = useState(null);

  const onSubmit = e => {
    onAdd(codeList.find(i => i.guid === selected));
  };

  const options = codeList
    ? codeList?.map(i => ({
        ...i,
        value: i.display,
        label: i.display,
      }))
    : [];

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        setSelected(null);
      }}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>افزودن گروه</DialogTitle>

      <DialogContent sx={{ width: '480px' }}>
        <FilledWrapper>
          <FilledLabel>انتخاب گروه</FilledLabel>
          <FormControl
            variant="standard"
            sx={{ width: '100%', paddingRight: 3 }}
            // error={!codeType && emptyError}
          >
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selected}
              onChange={e => setSelected(e.target.value)}
            >
              {options?.length ? (
                options?.map(code => (
                  <MenuItem
                    value={code.guid}
                    key={code.guid}
                    sx={{ direction: 'rtl' }}
                  >
                    {code.display}
                  </MenuItem>
                ))
              ) : (
                <p style={{ textAlign: 'center' }}>موردی یافت نشد</p>
              )}
            </Select>
          </FormControl>
        </FilledWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          type="submit"
          variant="contained"
          color="primary"
          disabled={selected == null}
          onClick={() => onSubmit()}
        >
          افزودن
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={() => {
            handleClose();
            setSelected(null);
          }}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

const StyledAutocomplete = styled(Autocomplete)({
  '& .MuiInputLabel-animated': {
    color: 'black',
  },
});

const FilledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledLabel = styled.label`
  width: 122px;
`;

export default CoddingGroupListAddModal;
